document.addEventListener("DOMContentLoaded", () => {
  // ✅ Local whitelist with names (no API calls)
  const sets = [
    { code: "2X2", name: "Double Masters 2022" },
    { code: "ACR", name: "Assassin’s Creed" },
    { code: "AFR", name: "Adventures in the Forgotten Realms" },
    { code: "BRO", name: "The Brothers’ War" },
    { code: "CLB", name: "Commander Legends: Battle for Baldur’s Gate" },
    { code: "DFT", name: "Aetherdrift" },
    { code: "DGM", name: "Dragon’s Maze" },
    { code: "DMU", name: "Dominaria United" },
    { code: "DSC", name: "Duskmourn: House of Horror Commander" },
    { code: "DSK", name: "Duskmourn: House of Horror" },
    { code: "FIN", name: "Final Fantasy" },
    { code: "GTC", name: "Gatecrash" },
    { code: "IKO", name: "Ikoria: Lair of Behemoths" },
    { code: "JOU", name: "Journey into Nyx" },
    { code: "KHM", name: "Kaldheim" },
    { code: "KLD", name: "Kaladesh" },
    { code: "LCI", name: "The Lost Caverns of Ixalan" },
    { code: "LTC", name: "Tales of Middle-earth Commander" },
    { code: "LTR", name: "The Lord of the Rings: Tales of Middle-earth" },
    { code: "M14", name: "Magic 2014 Core Set" },
    { code: "M15", name: "Magic 2015 Core Set" },
    { code: "M20", name: "Core Set 2020" },
    { code: "M21", name: "Core Set 2021" },
    { code: "MBS", name: "Mirrodin Besieged" },
    { code: "MH2", name: "Modern Horizons 2" },
    { code: "MH3", name: "Modern Horizons 3" },
    { code: "MID", name: "Innistrad: Midnight Hunt" },
    { code: "MKM", name: "Murders at Karlov Manor" },
    { code: "MOM", name: "March of the Machine" },
    { code: "NEO", name: "Kamigawa: Neon Dynasty" },
    { code: "NPH", name: "New Phyrexia" },
    { code: "ONE", name: "Phyrexia: All Will Be One" },
    { code: "ORI", name: "Magic Origins" },
    { code: "OTJ", name: "Outlaws of Thunder Junction" },
    { code: "OTP", name: "Outlaws of Thunder Junction: Breaking News" },
    { code: "PM20", name: "Core Set 2020 Promos" },
    { code: "RTR", name: "Return to Ravnica" },
    { code: "RVR", name: "Ravnica Remastered" },
    { code: "SNC", name: "Streets of New Capenna" },
    { code: "SOI", name: "Shadows over Innistrad" },
    { code: "STX", name: "Strixhaven: School of Mages" },
    { code: "TDM", name: "Tarkir Dragonstorm" },
    { code: "THB", name: "Theros Beyond Death" },
    { code: "THS", name: "Theros" },
    { code: "VOW", name: "Innistrad: Crimson Vow" },
    { code: "WAR", name: "War of the Spark" },
    { code: "WOE", name: "Wilds of Eldraine" },
    { code: "WOT", name: "Wilds of Eldraine: Enchanting Tales" },
    { code: "ZNR", name: "Zendikar Rising" }
  ];

  // ✅ Prepare alphabet
  const alphabet = [...new Set(sets.map(s => s.name[0].toUpperCase()))].sort();

  const alphabetBar = document.getElementById("alphabet-filter");
  const container = document.getElementById("set-container");

  // ✅ Build alphabet buttons
  alphabetBar.innerHTML = alphabet
    .map(letter => `<button data-letter="${letter}">${letter}</button>`)
    .join("");

  // ✅ Slugify for Shopify collection URLs
  const toSlug = name =>
    "/collections/singles-" +
    name.toLowerCase().replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, "-").trim();

  // ✅ Render sets for a given letter
  function renderSets(letter) {
    const filtered = sets.filter(s => s.name.startsWith(letter));
    container.innerHTML = filtered
      .map(
        s => `
      <div class="set-item">
        <i class="ss ss-${s.code.toLowerCase()}"></i>
        <a href="${toSlug(s.name)}">${s.name}</a>
      </div>
    `
      )
      .join("");
  }

  // ✅ Handle click events
  alphabetBar.querySelectorAll("button").forEach(btn => {
    btn.addEventListener("click", () => {
      alphabetBar.querySelectorAll("button").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      renderSets(btn.dataset.letter);
    });
  });

  // ✅ Auto-load first letter
  const first = alphabet[0];
  renderSets(first);
  document
    .querySelector(`#alphabet-filter button[data-letter="${first}"]`)
    ?.classList.add("active");
});
